import type { JSX } from 'react';
import { Badge } from '@/components/ui/badge';
import type { ExperienceStatus } from '../types/experience.types';
import { cn } from '@/lib/utils';

interface ExperienceStatusBadgeProps {
  status: ExperienceStatus;
  className?: string | undefined;
}

const statusConfig: Record<
  ExperienceStatus,
  {
    variant: 'default' | 'destructive' | 'secondary' | 'outline';
    label: string;
    customClass?: string;
  }
> = {
  DRAFT: {
    variant: 'secondary',
    label: 'Draft',
    customClass: 'bg-gray-100 text-gray-800 border-gray-300',
  },
  AWAITING: {
    variant: 'outline',
    label: 'Awaiting',
    customClass: 'bg-yellow-100 text-yellow-800 border-yellow-300',
  },
  CONFIRMED: {
    variant: 'default',
    label: 'Confirmed',
    customClass: 'bg-green-100 text-green-800 border-green-300',
  },
  REJECTED: {
    variant: 'destructive',
    label: 'Rejected',
    customClass: 'bg-red-100 text-red-800 border-red-300',
  },
};

export function ExperienceStatusBadge({
  status,
  className,
}: ExperienceStatusBadgeProps): JSX.Element {
  const { variant, label, customClass } = statusConfig[status];
  return (
    <Badge variant={variant} className={cn(customClass, className)}>
      {label}
    </Badge>
  );
}
